import { isEmpty } from 'lodash-es';
import { useEffect, useContext, createContext, useState, PropsWithChildren } from 'react';
import { csrfTokenCall } from 'wisestep-api';
import { ITokenContext } from 'wisestep-base';

export const TokenContext = createContext<ITokenContext | null>(null);
export default function TokenContextProvider(props: PropsWithChildren<ITokenContext | null>) {
  const [token, setToken] = useState<ITokenContext | null>(null);

  useEffect(() => {
    (async function () {
      if (isEmpty(token)) {
        try {
          const res = await csrfTokenCall();
          const token = res.config.headers?.['X-XSRF-TOKEN'];
          const auth = res.config.headers?.['Authorization'];
          setToken({ token: token ?? '', auth: auth ?? '' });
        } catch {
          setToken(null);
        }
      }
    })();
  }, [token]);

  return (
    <TokenContext.Provider value={{ ...token, setToken }}>{props.children}</TokenContext.Provider>
  );
}

export function useTokenContext() {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error('useAppState must be used within the TokenContextProvider');
  }
  return context;
}
